import React, { useEffect, useState } from 'react';
import apiClient from '../utils/api';

const AuthCallback = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const processCallback = async () => {
      
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');

      if (error) {
        console.error('OAuth error:', error);
        setError('Authentication failed. Please try again.');
        setTimeout(() => window.location.href = '/auth', 3000);
        return;
      }

      if (code) {
        try {
          console.log('AuthCallback: Processing code:', code);
          
          // Construct API URL based on current hostname
          const hostname = window.location.hostname;
          let apiUrl;
          
          if (hostname === 'localhost' || hostname === '127.0.0.1') {
            apiUrl = 'http://localhost:8000';
          } else {
            // Extract base domain (smartgtd.space or smartgtd.com)
            const baseDomain = hostname.replace('webapp.', '');
            apiUrl = `https://api.${baseDomain}`;
          }
          
          const redirectUri = `${window.location.origin}/auth/callback.html`;
          const callbackUrl = `${apiUrl}/auth/cognito-callback?code=${code}&redirect_uri=${encodeURIComponent(redirectUri)}`;
          
          console.log('AuthCallback: Calling backend:', callbackUrl);
          const response = await fetch(callbackUrl);
          
          console.log('AuthCallback: Response status:', response.status);
          
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error('AuthCallback: Backend error:', errorData);
            throw new Error(errorData.detail || 'Token exchange failed');
          }
          
          const data = await response.json();
          console.log('AuthCallback: Received tokens:', { 
            hasIdToken: !!data.id_token, 
            hasAccessToken: !!data.access_token,
            hasRefreshToken: !!data.refresh_token 
          });
          
          // Get Cognito config
          const configResponse = await fetch(`${apiUrl}/config`);
          const config = await configResponse.json();
          
          // Store tokens in Cognito SDK format
          const keyPrefix = `CognitoIdentityServiceProvider.${config.cognito.clientId}`;
          const username = data.user?.email || data.user?.sub || 'user';
          
          localStorage.setItem(`${keyPrefix}.LastAuthUser`, username);
          localStorage.setItem(`${keyPrefix}.${username}.idToken`, data.id_token);
          localStorage.setItem(`${keyPrefix}.${username}.accessToken`, data.access_token);
          if (data.refresh_token) {
            localStorage.setItem(`${keyPrefix}.${username}.refreshToken`, data.refresh_token);
          }
          
          console.log('AuthCallback: Tokens stored, redirecting to /');
          
          // Force reload to trigger auth context initialization
          window.location.href = '/';
        } catch (error) {
          console.error('Authentication error:', error);
          setError(error.message || 'Authentication failed. Please try again.');
          setTimeout(() => window.location.href = '/auth', 3000);
        }
      } else {
        window.location.href = '/auth';
      }
    };

    processCallback();
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '20px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px',
        animation: 'pulse 2s ease-in-out infinite'
      }}>
        <i className="fas fa-brain" style={{ color: 'white', fontSize: '2rem' }}></i>
      </div>
      <h1 style={{
        fontSize: '2rem',
        fontWeight: '800',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        marginBottom: '12px',
        letterSpacing: '-0.02em'
      }}>SmartGTD</h1>
      <p style={{
        fontSize: '1rem',
        color: error ? '#dc2626' : '#666',
        marginBottom: '32px',
        textAlign: 'center'
      }}>{error || 'Completing authentication...'}</p>
      {!error && (
      <div style={{ display: 'flex', gap: '8px' }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#667eea',
            animation: `bounce 1.4s ease-in-out ${i * 0.16}s infinite both`
          }}></div>
        ))}
      </div>
      )}
      
      <style jsx>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4); }
          50% { transform: scale(1.05); box-shadow: 0 0 0 20px rgba(102, 126, 234, 0); }
        }
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default AuthCallback;
